import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'components/Modal';
import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from 'components/Dialog';
import { BillingItem, HoverSelect, Content, Title, Description, ItemIcon } from '../BillingItem';
import Icon from '../../../components/Icon';
import styles from './CreateBillingMethodModal.m.sass';
var CreateBillingMethodModal = observer(_class = /*#__PURE__*/function (_React$Component) {
  function CreateBillingMethodModal() {
    _classCallCheck(this, CreateBillingMethodModal);
    return _callSuper(this, CreateBillingMethodModal, arguments);
  }
  _inherits(CreateBillingMethodModal, _React$Component);
  return _createClass(CreateBillingMethodModal, [{
    key: "render",
    value: function render() {
      var state = this.props.state;
      var creditExists = state.billingStore.billingMethods.find(function (x) {
        return x.type === 'Credit' && x.inactive === false && x.team_id === state.team.id;
      });
      return /*#__PURE__*/React.createElement(Modal, {
        onRequestClose: function onRequestClose() {
          return state.hideCreateBillingModal();
        },
        isOpened: state.showingCreateBillingModal,
        position: "top"
      }, /*#__PURE__*/React.createElement(Dialog, {
        className: styles.dialog
      }, !state.billingStore.rootStore.sessionStore.workspace.corporate && /*#__PURE__*/React.createElement("img", {
        className: styles.img,
        src: require('../../../assets/img/graphicAddPaymentMethod.svg')
      }), /*#__PURE__*/React.createElement(DialogTitle, {
        className: styles.dialogTitle
      }, "Add Payment Method", /*#__PURE__*/React.createElement("p", {
        className: styles.subTitle
      }, "Select an appropriate option from the list below")), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(BillingItem, {
        borderColor: "taxfyleBlue",
        onClick: function onClick(e) {
          return e.stopPropagation() || state.addBillingMethod();
        }
      }, /*#__PURE__*/React.createElement(HoverSelect, {
        bgColor: "taxfyleBlue"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "checkmark",
        className: styles.checkmark
      }), /*#__PURE__*/React.createElement("span", null, "Select")), /*#__PURE__*/React.createElement(ItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "credit card"
      })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("strong", null, "Credit Card")), /*#__PURE__*/React.createElement(Description, null, "Using your own credit card allows you to pay for your job requests up front."))), /*#__PURE__*/React.createElement(BillingItem, {
        borderColor: "taxfyleBlue",
        disabled: creditExists,
        onClick: function onClick(e) {
          return e.stopPropagation() || state.addCreditBillingMethod();
        }
      }, /*#__PURE__*/React.createElement(HoverSelect, {
        bgColor: "taxfyleBlue"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "checkmark",
        className: styles.checkmark
      }), /*#__PURE__*/React.createElement("span", null, "Select")), /*#__PURE__*/React.createElement(ItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "credit card"
      })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("strong", null, "Taxfyle Credit Account", creditExists && /*#__PURE__*/React.createElement("span", {
        className: styles.warning
      }, "\xA0- Limited to only one."))), /*#__PURE__*/React.createElement(Description, null, "Allows you to credit your account when making requests and allowing you to pay at a later date.")))), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButton, {
        onClick: function onClick() {
          return state.hideCreateBillingModal();
        }
      }, "Cancel"))));
    }
  }]);
}(React.Component)) || _class;
export { CreateBillingMethodModal as default };
//# sourceMappingURL=index.js.map
